/**
 * @hidden
 */
export const zoomIn = 'pdfviewer.zoomIn';
/**
 * @hidden
 */
export const zoomOut = 'pdfviewer.zoomOut';
/**
 * @hidden
 */
export const enableSelection = 'pdfviewer.enableSelection';
/**
 * @hidden
 */
export const enablePanning = 'pdfviewer.enablePanning';
/**
 * @hidden
 */
export const search = 'pdfviewer.search';
/**
 * @hidden
 */
export const open = 'pdfviewer.open';
/**
 * @hidden
 */
export const download = 'pdfviewer.download';
/**
 * @hidden
 */
export const print = 'pdfviewer.print';
/**
 * @hidden
 */
export const close = 'pdfviewer.close';
/**
 * @hidden
 */
export const matchCase = 'pdfviewer.matchCase';
/**
 * @hidden
 */
export const prevMatch = 'pdfviewer.prevMatch';
/**
 * @hidden
 */
export const nextMatch = 'pdfviewer.nextMatch';
/**
 * @hidden
 */
export const actualWidth = 'pdfviewer.actualWidth';
/**
 * @hidden
 */
export const fitToWidth = 'pdfviewer.fitToWidth';
/**
 * @hidden
 */
export const fitToPage = 'pdfviewer.fitToPage';
/**
 * @hidden
 */
export const popupBlocked = 'pdfviewer.popupBlocked';
/**
 * @hidden
 */
export const messages = {
    [zoomIn]: 'Zoom in',
    [zoomOut]: 'Zoom out',
    [enableSelection]: 'Enable selection',
    [enablePanning]: 'Enable panning',
    [search]: 'Search',
    [open]: 'Open',
    [download]: 'Download',
    [print]: 'Print',
    [close]: 'Close',
    [matchCase]: 'Match case',
    [prevMatch]: 'Previous match',
    [nextMatch]: 'Next match',
    [actualWidth]: 'Actual width',
    [fitToWidth]: 'Fit to width',
    [fitToPage]: 'Fit to page',
    [popupBlocked]: 'Popup is blocked.'
};
